export default __webpack_public_path__ + "static/media/trx.31fbbd99.png";